.Caption {
  display: block;
  font-size: var(--text-body-size-small);
  color: var(--fgColor-muted);

  &:where([data-control-disabled]) {
    color: var(--control-fgColor-disabled);
  }
}
